import { Component, TemplateRef, ViewChild, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { EMPTY, catchError, first, switchMap } from 'rxjs';
import { Constants } from 'src/app/core/constants';
import { Languages } from 'src/app/core/enums/languages.enum';
import { ErrorModel } from 'src/app/core/models/error-model.interface';
import { RegistrationUserFormModel } from 'src/app/core/models/user/registration-user-form.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { Convertor } from 'src/app/core/utils/convertor';

@Component({
    selector: 'app-registration',
    templateUrl: './registration.component.html',
    styleUrls: ['./registration.component.scss'],
    providers: [RegistrationUserFormModel],
    standalone: false
})
export class RegistrationComponent {
  formModel = inject(RegistrationUserFormModel);
  private authService = inject(AuthService);
  private toastService = inject(ToastService);
  private translateService = inject(TranslateService);

  @ViewChild('dangerTpl')
  public dangerTpl!: TemplateRef<unknown>;

  public readonly languages = Constants.SupportedLanguages;

  // These fields just for ease of use on template
  public emailFormControl: FormControl<string>;
  public passwordFormControl: FormControl<string>;

  public callbackError?: string;

  constructor() {
    const formModel = this.formModel;

    this.emailFormControl = formModel.form.controls.email;
    this.passwordFormControl = formModel.form.controls.password;

    const language =
      window.localStorage.getItem('interfaceLanguage') ??
      Constants.DefaultLanguage;

    this.formModel.form.controls.interfaceLanguage.setValue(
      Languages[language as keyof typeof Languages],
    );
  }

  public submitForm(): void {
    const user = this.formModel.form.getRawValue();

    this.authService
      .signUp(user)
      .pipe(
        first(),
        switchMap(() => this.authService.signIn(user)),
        catchError((error) => {
          const errorModel = error.error as ErrorModel;

          const i128nKey = Convertor.pascalToScreamingSnakeCase(
            errorModel.i18nKey,
          );
          const translatedMessage = this.translateService.instant(
            `ERRORS.${i128nKey}`,
          );

          this.callbackError = translatedMessage;
          this.toastService.show({
            template: this.dangerTpl,
            className: 'bg-danger text-light',
          });

          return EMPTY;
        }),
      )
      .subscribe();
  }
}
